export function getAppPathFromUrl(url?: string | null): string | null {
    if (!url) return null

    try {
        const parsed = new URL(url)

        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
            const path = `${parsed.pathname}${parsed.search}${parsed.hash}`.trim()
            return path.length > 0 ? path : '/'
        }

        const hostPath = parsed.hostname ? `/${parsed.hostname}` : ''
        const fullPath = `${hostPath}${parsed.pathname}${parsed.search}${parsed.hash}`.trim()
        return fullPath.length > 0 ? fullPath : '/'
    } catch {
        const sanitizedPath = url
            .replace(/^https?:\/\/(?:dev\.)?group\.splitcard\.com/i, '')
            .replace(/^:\/\//, '/')
            .replace(/^\/+/, '/')
            .trim()

        return sanitizedPath.length > 0 ? sanitizedPath : '/'
    }
}
